// extracted by mini-css-extract-plugin
export default {"container":"InputContainer_container__gZrtC","hidden":"InputContainer_hidden__aeThB"};